export const FLUSH_ALL = 'FLUSH_ALL';

export function flushAllRequest() {
    return {
        type: FLUSH_ALL
    }
}

export function flushAll() {
    return (dispatch) => {
        dispatch(flushAllRequest());
    }
}
